function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M637.45,457.22,624,451.85l12-8.14a242.72,242.72,0,0,0,65-337,242.66,242.66,0,1,0-336.95,337l12,8.14-13.46,5.37C221.68,514,130.49,648.93,130.34,800.9V911a89.13,89.13,0,0,0,89,89H780.63a89.13,89.13,0,0,0,89-89V799.65C869.05,648.28,777.87,513.84,637.45,457.22Zm-323-215.17c0-102.29,83.24-185.53,185.53-185.53s185.53,83.24,185.53,185.53S602.29,427.58,500,427.58,314.47,344.34,314.47,242.05ZM812.58,910.88a32,32,0,0,1-31.9,31.85H219.37a31.94,31.94,0,0,1-31.9-31.9V799.65a313.2,313.2,0,0,1,313-313.29h.1c172.57,0,313.09,140.42,313.19,313Z"
});

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.09f0596b.svg";
export { ForwardRef as ReactComponent };